import React, { useEffect, useState } from "react";
import "react-toastify/dist/ReactToastify.css";
import { Link, useParams } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import axios from "axios";

const FeePaymentList = () => {
  const { id } = useParams(); // Get the student ID from the URL
  const [student, setStudent] = useState({});
  const [tuitionFees, setTuitionFees] = useState([]);
  const [transportationFees, setTransportationFees] = useState([]);
  const [examFees, setExamFees] = useState([]);
  const [otherFees, setOtherFees] = useState([]);

  const allMonths = [
    "January",
    "Febuary",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const allExams = ["Term 1", "Term2", "Final Exam"];

  const allOtherFees = [
    "Uniform Fees",
    "Book Fees",
    "Re-Admission Fee",
    "Admission Fee",
  ];

  useEffect(() => {
    // Fetch student data to pre-fill the form
    const fetchStudentData = async () => {
      try {
        const token = JSON.parse(localStorage.getItem("token"));
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/student/fetch/${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.status === 200) {
          setStudent(response.data); // Set the form data with the fetched student details
        } else {
          toast.error("Failed to fetch student data.");
        }
      } catch (error) {
        toast.error("An error occurred while fetching student data.");
      }
    };
    const fetchFeesDetails = async () => {
      try {
        const token = JSON.parse(localStorage.getItem("token"));
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/fees/payment/fetch/${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.status === 200) {
          console.log(response.data);
          const tuitionFees = response.data.filter(
            (fee) => fee.paymentType === "tuition_fee"
          );
          setTuitionFees(tuitionFees);

          const transportationFees = response.data.filter(
            (fee) => fee.paymentType === "transportation_fee"
          );
          setTransportationFees(transportationFees);

          const examFees = response.data.filter(
            (fee) => fee.paymentType === "exam_fee"
          );
          setExamFees(examFees);

          const otherFees = response.data.filter(
            (fee) => fee.paymentType === "other_fee"
          );
          setOtherFees(otherFees);
        } else {
          // toast.error("Failed to fetch student data.");
        }
      } catch (error) {
        // toast.error("An error occurred while fetching student data.");
      }
    };

    fetchStudentData();
    fetchFeesDetails();
  }, [id]); // Re-run if the `id` changes
  const handleSubmit = async () => {
    try {
      const token = JSON.parse(localStorage.getItem("token"));
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}:${process.env.REACT_APP_API_PORT}/fees/payment/${id}`,
        { fees_details: feesDetails },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 201 || response.status === 200) {
        toast.success("Fees details added/updated successfully.");
      } else {
        toast.error("Failed to add/update fees details.");
      }
    } catch (error) {
      toast.error("An error occurred while submitting fees details.");
    }
  };

  return (
    <>
      <div className="container mt-5 bg-white rounded p-5 mb-5">
        <div className="row">
          <div className="col-12 d-flex justify-content-between align-items-center">
            <Link
              to={`/erp/fees/payment/class/${student.student_class}`}
              className="btn btn-secondary mb-3"
            >
              &#8592; Back to Student List
            </Link>
            <h3 className="text-center text-success">
              Fees Payment List of {student.student_name}
            </h3>
          </div>
          <div className="text-center d-flex justify-content-end">
            <h5>Student ID - {id}</h5>
          </div>
        </div>

        {/* Monthly Fees */}

        <div className="mb-5 mt-3">
          <div className="accordion" id="accordionPanelsStayOpenExample">
            <div className="accordion-item">
              <h2 className="accordion-header">
                <button
                  className="accordion-button"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#panelsStayOpen-collapseOne"
                  aria-expanded="true"
                  aria-controls="panelsStayOpen-collapseOne"
                >
                  Monthly Tuition Fees
                </button>
              </h2>
              <div
                id="panelsStayOpen-collapseOne"
                className="accordion-collapse collapse show"
              >
                <div className="accordion-body">
                  <table className="table table-striped table-hover table-bordered text-center">
                    <thead className="table-dark">
                      <tr>
                        <th>#</th>
                        <th style={{ width: "15rem" }}>Fees Payment Month</th>
                        <th style={{ width: "15rem" }}>Fees Payment Status</th>
                        <th>Amount</th>
                        <th style={{ width: "20rem" }}>Remarks</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {allMonths.map((month, index) => {
                        // Check if the month is in the fetched tuition fees
                        const fee = tuitionFees.find(
                          (fee) => fee.month === month
                        );
                        const isPaid = tuitionFees.some(
                          (fee) => fee.month === month
                        );

                        const amount = fee ? fee.amount : "";
                        return (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{month}</td>
                            <td>
                              <span
                                className={`badge ${
                                  isPaid ? "bg-success" : "bg-danger"
                                }`}
                              >
                                {isPaid ? "Paid" : "Unpaid"}
                              </span>
                            </td>
                            <td>
                              <span>
                                {amount !== "" ? `Rs. ${amount}` : amount}
                              </span>
                            </td>
                            <td>
                              <span>{fee && fee.remark ? fee.remark : ""}</span>
                            </td>
                            <td>
                              {isPaid ? (
                                <Link
                                  to={`/erp/fee-receipt/${id}?type=tuition_fee&month=${month}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <button className="btn btn-info btn-sm">
                                    View Receipt
                                  </button>
                                </Link>
                              ) : (
                                <Link
                                  to={`/erp/fees/payment/${id}?type=tuition_fee&month=${month}`}
                                >
                                  <button className="btn btn-warning btn-sm">
                                    Pay Fees
                                  </button>
                                </Link>
                              )}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            {/* Transportation Fees */}
            {student.transportation && (
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#panelsStayOpen-collapseTwo"
                    aria-expanded="false"
                    aria-controls="panelsStayOpen-collapseTwo"
                  >
                    Monthly Transportation Fees
                  </button>
                </h2>
                <div
                  id="panelsStayOpen-collapseTwo"
                  className="accordion-collapse collapse"
                >
                  <div className="accordion-body">
                    <table className="table table-striped table-hover table-bordered text-center">
                      <thead className="table-dark">
                        <tr>
                          <th>#</th>
                          <th>Fees Payment Month</th>
                          <th>Fees Payment Status</th>
                          <th>Amount</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {allMonths.map((month, index) => {
                          // Check if the month is in the fetched tuition fees
                          const fee = transportationFees.find(
                            (fee) => fee.month === month
                          );
                          const isPaid = transportationFees.some(
                            (fee) => fee.month === month
                          );
                          const amount = fee ? fee.amount : "";
                          return (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{month}</td>
                              <td>
                                <span
                                  className={`badge ${
                                    isPaid ? "bg-success" : "bg-danger"
                                  }`}
                                >
                                  {isPaid ? "Paid" : "Unpaid"}
                                </span>
                              </td>
                              <td>
                                <span>
                                  {amount !== "" ? `Rs. ${amount}` : amount}
                                </span>
                              </td>
                              <td>
                                {isPaid ? (
                                  <Link
                                    to={`/erp/fee-receipt/${id}?type=transportation_fee&month=${month}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    <button className="btn btn-info btn-sm">
                                      View Receipt
                                    </button>
                                  </Link>
                                ) : (
                                  <Link
                                    to={`/erp/fees/payment/${id}?type=transportation_fee&month=${month}`}
                                  >
                                    <button className="btn btn-warning btn-sm">
                                      Pay Fees
                                    </button>
                                  </Link>
                                )}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            )}

            {/* Exam Fees */}
            <div className="accordion-item">
              <h2 className="accordion-header">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#panelsStayOpen-collapseThree"
                  aria-expanded="false"
                  aria-controls="panelsStayOpen-collapseThree"
                >
                  Examination Fees
                </button>
              </h2>
              <div
                id="panelsStayOpen-collapseThree"
                className="accordion-collapse collapse"
              >
                <div className="accordion-body">
                  <table className="table table-striped table-hover table-bordered text-center">
                    <thead className="table-dark">
                      <tr>
                        <th>#</th>
                        <th>Exam Name</th>
                        <th>Fees Payment Status</th>
                        <th>Amount</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {allExams.map((exam_name, index) => {
                        const fee = examFees.find(
                          (fee) => fee.examName === exam_name
                        );
                        const isPaid = examFees.some(
                          (fee) => fee.examName === exam_name
                        );
                        const amount = fee ? fee.amount : "";
                        return (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{exam_name}</td>
                            <td>
                              <span
                                className={`badge ${
                                  isPaid ? "bg-success" : "bg-danger"
                                }`}
                              >
                                {isPaid ? "Paid" : "Unpaid"}
                              </span>
                            </td>
                            <td>
                              <span>
                                {amount !== "" ? `Rs. ${amount}` : amount}
                              </span>
                            </td>
                            <td>
                              {isPaid ? (
                                <Link
                                  to={`/erp/fee-receipt/${id}?type=exam_fee&exam=${exam_name}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <button className="btn btn-info btn-sm">
                                    View Receipt
                                  </button>
                                </Link>
                              ) : (
                                <Link
                                  to={`/erp/fees/payment/${id}?type=exam_fee&exam=${exam_name}`}
                                >
                                  <button className="btn btn-warning btn-sm">
                                    Pay Fees
                                  </button>
                                </Link>
                              )}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            {/* Other Fees */}

            <div className="accordion-item">
              <h2 className="accordion-header">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#panelsStayOpen-collapseFour"
                  aria-expanded="false"
                  aria-controls="panelsStayOpen-collapseFour"
                >
                  Other Fees
                </button>
              </h2>
              <div
                id="panelsStayOpen-collapseFour"
                className="accordion-collapse collapse"
              >
                <div className="accordion-body">
                  <table className="table table-striped table-hover table-bordered text-center">
                    <thead className="table-dark">
                      <tr>
                        <th>#</th>
                        <th>Other Fee Name</th>
                        <th>Fees Payment Status</th>
                        <th>Amount</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {allOtherFees.map((other_fee_name, index) => {
                        // Check if the month is in the fetched tuition fees
                        const fee = otherFees.find(
                          (fee) => fee.otherFeeName === other_fee_name
                        );
                        const isPaid = otherFees.some(
                          (fee) => fee.otherFeeName === other_fee_name
                        );
                        const amount = fee ? fee.amount : "";
                        return (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{other_fee_name}</td>
                            <td>
                              <span
                                className={`badge ${
                                  isPaid ? "bg-success" : "bg-danger"
                                }`}
                              >
                                {isPaid ? "Paid" : "Unpaid"}
                              </span>
                            </td>
                            <td>
                              <span>
                                {amount !== "" ? `Rs. ${amount}` : amount}
                              </span>
                            </td>
                            <td>
                              {isPaid ? (
                                <Link
                                  to={`/erp/fee-receipt/${id}?type=other_fee&fee_name=${other_fee_name}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <button className="btn btn-info btn-sm">
                                    View Receipt
                                  </button>
                                </Link>
                              ) : (
                                <Link
                                  to={`/erp/fees/payment/${id}?type=other_fee&fee_name=${other_fee_name}`}
                                >
                                  <button className="btn btn-warning btn-sm">
                                    Pay Fees
                                  </button>
                                </Link>
                              )}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ToastContainer />
      </div>
    </>
  );
};

export default FeePaymentList;
